module.exports = __webpack_public_path__ + "static/media/Mars6.7576b2e5.jpg";